import React from 'react';

const Loader = ({ color, shade = 500, size = 18, oldButtonType = null }) => {
  // TODO: remove this once we have a new button component, currentColor should be used in the new button component
  const buttonPrimary = oldButtonType === 'primary';

  // The rotation is a CSS transform animation on an HTML wrapper rather than SVG <animateTransform>:
  // the browser runs it off the main thread, so the spinner keeps turning while heavy work (PDF
  // rendering) blocks the page. The arc's SMIL stroke animation pauses during such work.
  return (
    <span className="inline-flex shrink-0 animate-[spin_2s_linear_infinite] motion-reduce:animate-none">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className={color ? `text-${color}-${shade}` : ''}>
        <rect x="0" y="0" width="24" height="24" rx="8" fill="none" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill={buttonPrimary ? 'white' : 'currentColor'}
          x="0"
          y="0"
          width="24"
          height="24">
          <g stroke={buttonPrimary ? 'white' : 'currentColor'}>
            <circle cx="12" cy="12" r="9.5" fill="none" strokeLinecap="round" strokeWidth="3">
              <animate
                attributeName="stroke-dasharray"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                keyTimes="0;0.475;0.95;1"
                repeatCount="indefinite"
                values="0 150;42 150;42 150;42 150"
              />
              <animate
                attributeName="stroke-dashoffset"
                calcMode="spline"
                dur="1.5s"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                keyTimes="0;0.475;0.95;1"
                repeatCount="indefinite"
                values="0;-16;-59;-59"
              />
            </circle>
          </g>
        </svg>
      </svg>
    </span>
  );
};

export default Loader;
